import { Component, ChangeDetectorRef } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { InvDailyDetail, InvDailyHeader } from "../../model/inv-daily-header.model";

@Component({
  selector: "ngx-inv-daily-listdialog",
  templateUrl: "./inv-daily-listdialog.component.html",
  styleUrls: ["./inv-daily-listdialog.component.scss"],
})
export class InvDailyListDialogComponent extends BaseFormComponent<InvDailyHeader> {
  selectedRowDetails: InvDailyDetail[];
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }

  async ngOnInit() {
    this.apiName = "InvDailyHeader";
    this.label = this.translate("ClientApp.Pages.PageMenu.InvDailyHeader");
  }

  close() {
    this.closeModal();
  }

  confirm() {
    if (!this.selectedRowDetails) {
      this.sts.showToast("warning", this.translate("ClientApp.FrontOffice.Inv.DailyHeader.NoneOfRowsSelected"));
      return;
    }
    this.selectedRowDetails.forEach((x) => {
      x.Id = 0;
      x.Amount = 0;
    });
    this.result = this.selectedRowDetails;
    this.closeModal();
  }

  showInfo(e: InvDailyHeader) {
    e.InvDailyDetails.forEach((x) => {
      x.Id = 0;
      x.Amount = 0;
    });
    this.result = e.InvDailyDetails;
    this.closeModal();
  }

  onRowSelected(e: InvDailyHeader) {
    this.selectedRowDetails = e.InvDailyDetails;
  }
}
